/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as StatusRouteImport } from './routes/status'
import { Route as RequestAccessRouteImport } from './routes/request-access'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppsRouteImport } from './routes/apps'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthSetPasswordRouteImport } from './routes/auth.set-password'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestAccessRoute = RequestAccessRouteImport.update({
  id: '/request-access',
  path: '/request-access',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsRoute = AppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSetPasswordRoute = AuthSetPasswordRouteImport.update({
  id: '/auth/set-password',
  path: '/auth/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/apps': typeof AppsRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/request-access': typeof RequestAccessRoute
  '/status': typeof StatusRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/set-password': typeof AuthSetPasswordRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/apps': typeof AppsRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/request-access': typeof RequestAccessRoute
  '/status': typeof StatusRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/set-password': typeof AuthSetPasswordRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/apps': typeof AppsRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/request-access': typeof RequestAccessRoute
  '/status': typeof StatusRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/set-password': typeof AuthSetPasswordRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/apps'
    | '/login'
    | '/logout'
    | '/request-access'
    | '/status'
    | '/unauthorized'
    | '/auth/callback'
    | '/auth/set-password'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/apps'
    | '/login'
    | '/logout'
    | '/request-access'
    | '/status'
    | '/unauthorized'
    | '/auth/callback'
    | '/auth/set-password'
  id:
    | '__root__'
    | '/'
    | '/apps'
    | '/login'
    | '/logout'
    | '/request-access'
    | '/status'
    | '/unauthorized'
    | '/auth/callback'
    | '/auth/set-password'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppsRoute: typeof AppsRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  RequestAccessRoute: typeof RequestAccessRoute
  StatusRoute: typeof StatusRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/request-access': {
      id: '/request-access'
      path: '/request-access'
      fullPath: '/request-access'
      preLoaderRoute: typeof RequestAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps': {
      id: '/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AppsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/set-password': {
      id: '/auth/set-password'
      path: '/auth/set-password'
      fullPath: '/auth/set-password'
      preLoaderRoute: typeof AuthSetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppsRoute: AppsRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  RequestAccessRoute: RequestAccessRoute,
  StatusRoute: StatusRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
